import {useTranslation} from 'react-i18next';
import {FormTabType} from '../types';

type Props = {
  activeTab: FormTabType;
  onTabChange: (tab: FormTabType) => void;
  responseCount?: number;
  copyMode?: boolean;
};

function FormTabs({activeTab, onTabChange, responseCount, copyMode = false}: Props) {
  const {t} = useTranslation();

  const TABS: {key: FormTabType; label: string}[] = [
    {key: 'questions', label: t('forms.dialog.tabs.questions')},
    {key: 'settings', label: t('forms.dialog.tabs.settings')},
    ...(copyMode ? [] : [{key: 'responses' as FormTabType, label: t('forms.dialog.tabs.responses')}]),
  ];

  return (
    <div className="px-4">
      <div className="w-full flex justify-center items-center gap-2 bg-white border-b border-gray90">
        {TABS.map(tab => {
          const isActive = tab.key === activeTab;

          return (
            <button
              key={tab.key}
              type="button"
              className={`px-6 py-3 text-sm transition-colors flex items-center gap-1
              ${
                isActive
                  ? 'border-b-[3px] border-b-deepAqua font-medium text-black'
                  : 'text-darkerGray hover:text-black'
              }
            `}
              onClick={() => onTabChange(tab.key)}>
              {tab.label}
              {tab.key === 'responses' &&
                responseCount != null &&
                responseCount > 0 && (
                  <span className="bg-darkBlue text-white text-sm font-medium rounded-full w-6 h-6 flex items-center justify-center">
                    {responseCount}
                  </span>
                )}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default FormTabs;
